module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pm-page"
  }, [_c('div', {
    staticClass: "page-frame page-frame-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns text-center"
  }, [_c('img', {
    staticClass: "topbar-main-logo",
    attrs: {
      "src": _vm.logo
    }
  })])])]), _c('div', {
    staticClass: "off-canvas"
  }, [(_vm.title) ? _c('div', {
    staticClass: "top-bar show-for-large"
  }, [_c('div', {
    staticClass: "top-bar-left text-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.time))])]), _c('div', {
    staticClass: "top-bar-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _c('span', [_vm._v(" ")]), _c('i', {
    staticClass: "fa fa-retweet",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.reload
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "off-canvas-wrapper",
    attrs: {
      "data-off-canvas-wrapper": ""
    }
  }, [(_vm.userAuthenticated) ? _c('div', {
    directives: [{
      name: "f-off-canvas",
      rawName: "v-f-off-canvas"
    }],
    staticClass: "off-canvas-absolute position-left reveal-for-large",
    attrs: {
      "id": "offCanvasLeft",
      "data-off-canvas": ""
    }
  }, [_vm._m(0), _c('ul', {
    staticClass: "vertical menu"
  }, [_vm._l((_vm.menu_pages), function(item) {
    return _c('router-link', {
      class: item.name,
      attrs: {
        "to": {
          name: item.name
        },
        "tag": "li"
      }
    }, [_c('a', [_vm._v(_vm._s(item.display_name))]), (item.childrens) ? _c('ul', _vm._l((item.childrens), function(child) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": {
            name: child.name
          }
        }
      }, [_vm._v(_vm._s(child.display_name))])], 1)
    }), 0) : _vm._e()])
  }), _c('li', {
    staticClass: "no-icon router-link-active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Profile")]), _c('ul', [_c('li', [_c('div', [_c('small', [_c('span', [_vm._v(_vm._s(_vm.userStore.username) + " (ID: " + _vm._s(_vm.userStore.id) + ")")])])]), _c('div', [_c('small', [_c('span', [_vm._v(_vm._s(_vm.userStore.email))])])])])])]), _c('li', {
    staticClass: "no-icon router-link-active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Extra")]), _c('ul', _vm._l((_vm.extra_pages), function(page) {
    return _c('li', [_c('a', {
      attrs: {
        "href": page.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(page.name))])])
  }), 0)])], 2)]) : _vm._e(), _c('div', {
    staticClass: "title-bar hide-for-large"
  }, [_c('div', {
    staticClass: "title-bar-left row align-middle align-center"
  }, [_c('button', {
    staticClass: "menu-icon",
    attrs: {
      "type": "button",
      "data-toggle": "offCanvasLeft"
    }
  }), _c('span', {
    staticClass: "title-bar-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('i', {
    staticClass: "fa fa-2x fa-retweet",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.reload
    }
  })])]), (_vm.userAuthenticated) ? _c('div', {
    directives: [{
      name: "f-off-canvas",
      rawName: "v-f-off-canvas"
    }],
    staticClass: "offCanvasBig off-canvas-absolute position-right",
    attrs: {
      "id": "offCanvasRight",
      "data-off-canvas": ""
    }
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Close menu",
      "type": "button",
      "data-close": ""
    },
    on: {
      "click": _vm.destroy
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), (_vm.component) ? _c(_vm.component.component, _vm._b({
    tag: "component"
  }, 'component', _vm.component.props, false)) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "off-canvas-content",
    attrs: {
      "data-off-canvas-content": ""
    }
  }, [(_vm.component && _vm.component.position === 'top') ? _c('div', {
    attrs: {
      "id": "customCanvas"
    }
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Close menu",
      "type": "button",
      "data-close": ""
    },
    on: {
      "click": _vm.destroy
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c(_vm.component.component, _vm._b({
    tag: "component"
  }, 'component', _vm.component.props, false))], 1)])])]) : _vm._e(), (_vm.userAuthenticated) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 large-10"
  }, [(!_vm.hideForAcl) ? _c('breadcrumbs') : _vm._e()], 1), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "side-actions"
  }, [_c('QuickSearch')], 1), _vm._l((this.$route.meta.action), function(act) {
    return _c(act.component, {
      tag: "div",
      staticClass: "side-actions",
      attrs: {
        "type": "act",
        "item": act
      }
    })
  }), (_vm.action && !_vm.hideForAcl) ? _c(_vm.action.component, {
    tag: "div",
    staticClass: "side-actions",
    attrs: {
      "type": "action",
      "item": _vm.action
    }
  }) : _vm._e()], 2)]) : _vm._e(), _c('div', {
    staticClass: "is-hidden",
    attrs: {
      "id": "preloader"
    }
  }), _c('router-view', {
    key: _vm.$route.fullPath
  })], 1), _c('div', {
    staticClass: "rw"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-for-small-only",
    staticStyle: {
      "min-height": "50px"
    }
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Close menu",
      "type": "button",
      "data-close": ""
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f189216!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/OffCanvas.vue
// module id = 2378
// module chunks = 1